import { render, staticRenderFns } from "./ArticleAdmin.vue?vue&type=template&id=21d54fe9&"
import script from "./ArticleAdmin.vue?vue&type=script&lang=js&"
export * from "./ArticleAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports